import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/components/Sidebar.css";

const Sidebar = ({ expanded, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    navigate("/login");
  };

  const navItems = [
    { path: "/", icon: "📊", label: "Dashboard", iconClass: "dashboard" },
    { path: "/users", icon: "👥", label: "User Management", iconClass: "users" },
    { path: "/roles", icon: "🔐", label: "Access Control", iconClass: "roles" },
    { path: "/departments", icon: "🏢", label: "Departments", iconClass: "departments" },
    { path: "/transactions", icon: "📝", label: "Transactions", iconClass: "transactions" },
    { path: "/field-master", icon: "⚙️", label: "Field Master", iconClass: "field-master" },
    { path: "/field-master/projections", icon: "🔗", label: "Field Projections", iconClass: "field-projections" },
  ];

  return (
    <aside className={`sidebar ${expanded ? "expanded" : "collapsed"}`}>
      <div className="sidebar-header">
        <div className="brand-container">
          <span className="sidebar-icon" aria-hidden="true">🏭</span>
          {expanded && (
            <div className="brand-text">
              <span className="sidebar-title">Organisation Admin</span>
              <span className="sidebar-tagline">Enterprise ERP</span>
            </div>
          )}
        </div>
        {!isMobile && (
          <button onClick={toggleSidebar} className="toggle-button" aria-label="Toggle sidebar">
            {expanded ? "◀" : "▶"}
          </button>
        )}
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section-label">{expanded && "MAIN MENU"}</div>
        <div className="nav-links">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? "active" : ""} ${item.iconClass}`}
              title={!expanded ? item.label : ""}
              aria-current={location.pathname === item.path ? "page" : undefined}
            >
              <span className="nav-icon">{item.icon}</span>
              {expanded && <span className="nav-label">{item.label}</span>}
            </Link>
          ))}
        </div>

        {expanded && (
          <>
            <div className="nav-divider"></div>
            <div className="nav-section-label">SYSTEM</div>
            <div className="nav-links">
              <div className="nav-link disabled">
                <span className="nav-icon">📈</span>
                <span className="nav-label">Reports</span>
                <span className="coming-soon">Soon</span>
              </div>
              <div className="nav-link disabled">
                <span className="nav-icon">⚡</span>
                <span className="nav-label">Automation</span>
                <span className="coming-soon">Soon</span>
              </div>
            </div>
          </>
        )}
      </nav>

      <div className="sidebar-footer">
        {expanded && (
          <div className="system-status">
            <div className="status-row">
              <span className="status-dot online"></span>
              <span className="status-label">System Online</span>
            </div>
          </div>
        )}
        <button onClick={handleLogout} className="logout-button">
          <span className="logout-icon">🚪</span>
          {expanded && <span className="logout-text">Sign Out</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
